module.exports = __webpack_public_path__ + "assets/img/2ba05af3f04e6295253cf027fd2c1f71.svg";